module.exports = __webpack_public_path__ + "img/51.7ec3cec7.svg";